import styled, { css } from 'styled-components';

import { elevation, elevationTransition } from 'ggApp/utils/mixins/elevation';

import Typography from 'ggApp/shared/components/typography';
import CartIcon from 'ggApp/shared/icons/Cart';

const Wrap = styled.div`
    width: 48px;
    height: 48px;
    border-radius: 50%;
    position: relative;
    ${elevationTransition(false)};
    ${elevation(1, false)};
    &:hover {
        ${elevation(3, false)};
    }
    ${({ isClickable }) =>
        isClickable &&
        css`
            &:active {
                ${elevation(1, false)}
                transition-duration: 0s;
            }
        `}
    ${({ theme }) => theme.superQuery.all.and.minWidth.desktopMin.css`
        cursor: pointer;
        pointer-events: auto;
        &:hover {
            &:after {
                visibility: visible;
            }
        }
        &:after {
            visibility: hidden;
            content: "";
            display: block;
            position: absolute;
            right: 0px;
            width: 200%;
            height: 36px;
            bottom: -12px;
        }
    `}
`;

const UnstyledDiv = styled.div``;

const Button = styled.div`
    background: ${({ theme }) => theme.colors.ElementBackground};
    box-sizing: border-box;
    border-radius: 50%;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Icon = styled(CartIcon)`
    width: 24px;
    height: 24px;
    bottom: 0;
    right: 0;
`;

const QtyBadge = styled.div`
    position: absolute;
    background-color: #fe1251;
    top: 0px;
    right: -5px;
    min-width: 20px;
    max-width: 100%;
    height: 20px;
    border-radius: 12px;
    box-sizing: border-box;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 1px;
    overflow: hidden;
`;

const QtyTxt = styled(Typography)`
    color: #ffffff;
    letter-spacing: 0em !important;
`;

export { UnstyledDiv, Wrap, Button, Icon, QtyBadge, QtyTxt };
